import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, ViewChild, ViewEncapsulation, inject } from '@angular/core';
import { GtmGenericDialogsService, GtmImportPack, provideGtmGenericDialogsService } from '@partners/gtm';
import {
  DialogContainerComponent,
  DialogImportPack,
  FilledButtonComponent,
  FlexUtilsImportPack,
  IConfirmConfig,
  LinkButtonComponent
} from '@partners/ui';
import { InfoIconComponent } from '../../components';

/**
 * @description
 * a default confirm dialog ui. (read more documentation in file ../alert.component.ts)
 */

@Component({
  standalone: true,
  providers: [provideGtmGenericDialogsService()],
  imports: [
    FilledButtonComponent,
    LinkButtonComponent,
    FlexUtilsImportPack,
    DialogImportPack,
    InfoIconComponent,
    NgIf,
    GtmImportPack
  ],
  template: `
    <dialog-container #container gtmFunnelStepEvent="funnelStepEvent">
      <ng-template dialogIcon>
        <info-icon data-alt="אייקון אילוסטרציה שגיאה" />
      </ng-template>
      <ng-template dialogTitle let-context>
        <span>{{ context.title }}</span>
      </ng-template>
      <ng-template dialogBody let-context>
        <span>{{ context.message }}</span>
      </ng-template>
      <ng-template dialogFooter let-context>
        <div [layout]="context.footerLayout || 'column'" layout-align="center center" style="gap: 20px;">
          <div *ngIf="context.buttons.cancel" class="dialog-action">
            <link-button decoration="underline" (click)="dismissConfirm(false)" gtmClickEvent="cancelClickEvent">
              {{ context.buttons.cancel }} 
            </link-button>
          </div>
          <div class="dialog-action">
            <filled-button (click)="dismissConfirm(true)" class="primary-action-button" gtmClickEvent="confirmClickEvent">
              {{ context.buttons.confirm }}
            </filled-button>
          </div>
        </div>
      </ng-template>
    </dialog-container>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'confirm-dialog'
  }
})
export class ConfirmComponent implements OnInit {
  private readonly _gtmService = inject(GtmGenericDialogsService);

  @ViewChild('container', { static: true, read: DialogContainerComponent })
  dialogContainer: DialogContainerComponent;

  ngOnInit() {
    this.setGtmDialogConfig();
  }

  setGtmDialogConfig() {
    const dialogConfig = this.dialogContainer.dialogConfig as IConfirmConfig;

    const gtmDialogConfig = {
      message: dialogConfig.message,
      buttons: {
        confirm: dialogConfig.buttons?.confirm,
        cancel: dialogConfig.buttons?.cancel
      }
    };

    this._gtmService.setDialogConfig(gtmDialogConfig);
  }

  dismissConfirm(response: boolean) {
    this.dialogContainer.dismissDialog(response);
  }
}
